var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.applicationSid)?_c('application-list'):_c('show-applications',{attrs:{"sid":_vm.applicationSid}})}
var staticRenderFns = []

export { render, staticRenderFns }